import { ColumnDef } from '@tanstack/react-table'
import { components } from '@/schema'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { Badge } from '@/common/ui/badge'
import { LOG_TYPE_LABELS } from '../../constants'

type LineAutoMessageLogModel =
	components['schemas']['AdminLineAutoMessageLogModel']

export const columns: ColumnDef<LineAutoMessageLogModel>[] = [
	{
		accessorKey: 'createdAt',
		header: 'วันที่',
		cell: ({ row }) => {
			return format(new Date(row.original.createdAt), 'dd MMM yyyy HH:mm', {
				locale: th,
			})
		},
	},
	{
		accessorKey: 'logType',
		header: 'ประเภท',
		cell: ({ row }) => {
			const logType = row.original.logType
			const variant =
				logType === 'BROADCAST'
					? 'default'
					: logType === 'AUTO_REPLY'
						? 'secondary'
						: 'outline'
			return (
				<Badge variant={variant}>{LOG_TYPE_LABELS[logType] || logType}</Badge>
			)
		},
	},
	{
		accessorKey: 'message',
		header: 'ข้อความ',
		cell: ({ row }) => {
			const messages = row.original.message
			const preview = messages.length > 0 ? messages[0] : '-'
			const truncated =
				preview.length > 50 ? `${preview.substring(0, 50)}...` : preview
			return (
				<div className="max-w-[300px]">
					<span className="text-sm">{truncated}</span>
					{messages.length > 1 && (
						<span className="ml-2 text-xs text-muted-foreground">
							(+{messages.length - 1} ข้อความ)
						</span>
					)}
				</div>
			)
		},
	},
	{
		accessorKey: 'totalTargeted',
		header: 'เป้าหมาย',
		cell: ({ row }) => row.original.totalTargeted.toLocaleString(),
	},
	{
		accessorKey: 'successCount',
		header: 'สำเร็จ',
		cell: ({ row }) => (
			<span className="text-green-600">
				{row.original.successCount.toLocaleString()}
			</span>
		),
	},
	{
		accessorKey: 'failedCount',
		header: 'ล้มเหลว',
		cell: ({ row }) => (
			<span className="text-red-600">
				{row.original.failedCount.toLocaleString()}
			</span>
		),
	},
	{
		id: 'details',
		header: 'รายละเอียด',
		cell: ({ row }) => (
			<Button asChild variant="outline" size="sm">
				<Link to={`/operator/line-message-log/${row.original.id}`}>
					ดูรายละเอียด
				</Link>
			</Button>
		),
	},
]
